// extracted by mini-css-extract-plugin
module.exports = {"pageButton":"PageButton_pageButton__2_oJ7","selected":"PageButton_selected__3547Y"};